export default "__VITE_ASSET__BnvNbjLo__"